import React, { useState } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getDeliverables, deleteDeliverable } from "../../../api/deliverable";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button, Input, Row, Col } from "reactstrap";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";

export default function DeliverableList() {
    const navigate = useNavigate();
    const { dealId } = useParams();

    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const role = currentUser.role || currentUser.roleName || "";
    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Sales" && perm.actions.includes(action)
            )
        );
    };

    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("read");

    const {
        response,
        loading,
        error,
        setPage,
        page,
        setMeta,
        totalPages,
    } = usePagination(
        getDeliverables,
        { dealId },
        Boolean(dealId)
    );

    const [filters, setFilters] = useState({
        deliverable: "",
    });

    function handleFilter() {
        setMeta((m) => ({
            ...m,
            page: 1,
            payload: {
                ...filters,
                dealId, 
            },
        }));
    }

    const handleDelete = async (id) => {
        if (window.confirm(t("Are you sure you want to delete this deliverable?"))) {
            try {
                await deleteDeliverable(id);
                setPage(1);
            } catch (error) {
                console.error("Delete failed:", error);
                alert(t("Failed to delete deliverable."));
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs
                    title={`${t("Deliverable")} ${t("Table")}`}
                    // addUrl={dealId ? `/deliverables/add/${dealId}` : null}
                    // hasAddBtn={canCreate()}
                />

                {canRead() || canDelete() || canEdit() ? (
                    response && response.length > 0 && !loading ? (
                        <CustomTable
                            emptyMsg={t("No Deliverables Found.")}
                            data={response}
                            loading={loading}
                            error={error}
                            cols={[
                                {
                                    label: t("Timeline"),
                                    key: "timeline",
                                    style: { width: "20%" },
                                },
                                {
                                    label: t("Deliverable"),
                                    key: "deliverable",
                                    style: { width: "30%" },
                                },
                                {
                                    label: t("Notes"),
                                    key: "notes",
                                    style: { width: "30%" },
                                    renderer: (row) => row.notes || "-",
                                },
                                {
                                    label: t("Actions"),
                                    key: "actions",
                                    style: { width: "20%" },
                                    renderer: (row) => (
                                        <div className="d-flex gap-2">
                                            {canEdit() && (
                                                <Button
                                                    color="info"
                                                    size="sm"
                                                    onClick={() => navigate(`/deliverables/edit/${row._id}`)}
                                                >
                                                    {t("Edit")}
                                                </Button>
                                            )}
                                            {canDelete() && (
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(row._id)}
                                                >
                                                    {t("Delete")}
                                                </Button>
                                            )}
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    ) : (
                        !loading && <div>{t("No results found.")}</div>
                    )
                ) : (
                    <div>{t("You do not have permission to view this list.")}</div>
                )}

                {response && !loading && canRead() && (
                    <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
                )}
            </div>
        </div>
    );
}
